import common from './common';
import siteMetadata from './site-metadata';
import home from './home';
import about from './about';
import blog from './blog';
import onlineWills from './online-wills';
import guard from './guardianship';
import epa from './epa';
import estateSession from './estate-session';
import storage from './storage';
import pricing from './pricing';
import contact from './contact';
import charities from './charities';
import premium from './premium';
import partnerships from './partnerships';
import comparison from './comparison';
import countrySpecificWills from './country-specific-wills';
import faq from './faq';
import newHome from './new-home';

export default {
    ...common,
    ...siteMetadata,
    ...home,
    ...about,
    ...blog,
    ...onlineWills,
    ...guard,
    ...epa,
    ...estateSession,
    ...storage,
    ...pricing,
    ...contact,
    ...charities,
    ...premium,
    ...partnerships,
    ...comparison,
    ...countrySpecificWills,
    ...faq,
    ...newHome,
};
